import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
// *** Services
import { SessionActions, } from "services";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import Group from "@material-ui/icons/Group";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import InfoArea from "components/InfoArea/InfoArea.js";

import style from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";
import { UsuarioContext } from "config/context/UsuarioProvider";


const useStyles = makeStyles(style);
var pinRef = React.createRef();

export default function EnvioCI() {
    const history = useHistory();
    const { usuario, setusuario, signupModalPin, setSignupModalPin } = useContext(
        UsuarioContext
    );
    const infoStyle = {
        infoArea: {
            maxWidth: "automax-content",
            margin: "0 auto",
            padding: "0px"
        }
    }
    const classesInfo = useStyles(infoStyle);
    const [colorBoton, setcolorBoton] = useState("primary");
    const classes = useStyles();
    const Transition = React.forwardRef(function Transition(props, ref) {
        return <Slide direction="down" ref={ref} {...props} />;
      });
    return (
        <div>
            <Dialog
                disableBackdropClick
                classes={{
                    root: classes.modalRoot,
                    paper: classes.modal + " " + classes.modalSignup,
                }}
                open={true}
                onClose={() => {
                    localStorage.clear();
                    SessionActions.logout();
                    history.push("/");
                }}
                TransitionComponent={Transition}
                keepMounted
                aria-labelledby="signup-modal-slide-title"
                aria-describedby="signup-modal-slide-description"
            >
                <Card plain className={classes.modalSignupCard}>
                    <DialogTitle
                        id="signup-modal-slide-title"
                        disableTypography
                        className={classes.modalHeader}
                    >
                        <h3 className={classes.cardTitle + " " + classes.modalTitle}>
                            Cédula de identidad enviada exitosamente
                        </h3>
                    </DialogTitle>
                    <DialogContent
                        id="signup-modal-slide-description"
                        className={classes.modalBody}
                    >
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                                <InfoArea
                                    title="¿Cuáles son los pasos a seguir?"
                                    description={
                                        <div className={classes.title} style={{ textAlign: "justify" }}>
                                            <h5>
                                                Uno de nuestros operadores ya fue informado para realizar la validación manual, en breve nos pondremos en contacto para continuar con la descarga del certificado.
                                            </h5>
                                        </div>
                                    }
                                    icon={Group}
                                    iconColor="info"
                                />
                                <div className={classes.textCenter}>
                                    <Button
                                        color="primary"
                                        onClick={(event) => {
                                            localStorage.clear();
                                            SessionActions.logout();
                                            history.push("/");
                                        }}
                                    >
                                        Salir y esperar que me contacten
                                    </Button>
                                </div>
                            </GridItem>
                        </GridContainer>
                    </DialogContent>
                </Card>
            </Dialog>
        </div>
    );
}
